import { Analytics } from "analytics";
import { init } from "@analytics/google-analytics";
import { a as PUBLIC_GOOGLE_ANALYTICS_ID, b as PUBLIC_GOOGLE_ANALYTICS_TAG } from "./public.js";
const analytics = Analytics({
  app: PUBLIC_GOOGLE_ANALYTICS_ID,
  plugins: [
    init({
      measurementIds: [PUBLIC_GOOGLE_ANALYTICS_TAG]
    })
  ]
});
export {
  analytics as a
};
